import { render, staticRenderFns } from "./SettingEffective.vue?vue&type=template&id=10aa8884"
import script from "./SettingEffective.vue?vue&type=script&lang=js"
export * from "./SettingEffective.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports